import React from 'react';
import { getStyles } from './Icons';
export var ArrowFowardIcon = function (props) { return (React.createElement("svg", { focusable: "false", style: getStyles(props), viewBox: "0 0 24 24", "aria-hidden": "true", role: "presentation" },
    React.createElement("path", { d: "M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z" }))); };
//# sourceMappingURL=ArrowFowardIcon.js.map